import { useMutation } from "@tanstack/react-query";
import {
  createSwitchTransaction,
  deleteSwitchTransactionApi,
  updateSwitchTransactionApi,
} from "../../api/transaction/switch";
import { useInvalidateTransactionOrder } from "./transaction";

export const useCreateSwitchTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/switch/create"],
    mutationFn: createSwitchTransaction,
    onSuccess: invalidate,
  });
};

export const useDeleteSwitchTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/switch/delete"],
    mutationFn: deleteSwitchTransactionApi,
    onSuccess: invalidate,
  });
};

export const useUpdateSwitchTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/switch/update"],
    mutationFn: updateSwitchTransactionApi,
    onSuccess: invalidate,
  });
};
